import { render, staticRenderFns } from "./PurchaseInvoiceAdd.vue?vue&type=template&id=4adb2de3&scoped=true"
import script from "./PurchaseInvoiceAdd.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceAdd.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvoiceAdd.vue?vue&type=style&index=0&id=4adb2de3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adb2de3",
  null
  
)

export default component.exports